export default {
  BEFORE_JACKPOT_SIGN_TIMEOUT: 12500,
  COEFS_HISTORY_COUNT: 12,
  MAX_MY_BETS_HISTORY: 100,
}
